import { useState, Children, cloneElement, isValidElement } from 'react'
import { CaretDownIcon } from '@phosphor-icons/react'
import styles from './ScoopAccordion.module.scss'

export const ScoopAccordion = ({
    children,
    expanded: controlledExpanded,
    defaultExpanded = false,
    onChange,
    className = '',
    disabled = false,
}) => {
    const [internalExpanded, setInternalExpanded] = useState(defaultExpanded)

    const isControlled = controlledExpanded !== undefined
    const expanded = isControlled ? controlledExpanded : internalExpanded

    const handleToggle = () => {
        if (disabled) return

        const newExpanded = !expanded
        if (!isControlled) {
            setInternalExpanded(newExpanded)
        }
        onChange?.(null, newExpanded)
    }

    // Inject onClick into ScoopAccordionSummary children
    const enhancedChildren =
        typeof children === 'function'
            ? children({ expanded, onToggle: handleToggle })
            : Children.map(children, (child) => {
                  if (isValidElement(child) && child.type === ScoopAccordionSummary) {
                      return cloneElement(child, { onClick: handleToggle })
                  }
                  return child
              })

    return (
        <div
            className={`${styles.accordion} ${expanded ? styles.expanded : ''} ${disabled ? styles.disabled : ''} ${className}`}
        >
            {enhancedChildren}
        </div>
    )
}

export const ScoopAccordionSummary = ({ children, expandIcon, onClick, className = '' }) => {
    return (
        <div
            className={`${styles.summary} ${className}`}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    onClick?.()
                }
            }}
        >
            <div className={styles.summaryContent}>{children}</div>
            <div className={styles.expandIcon}>{expandIcon || <CaretDownIcon size={16} />}</div>
        </div>
    )
}

export const ScoopAccordionDetails = ({ children, className = '' }) => {
    return (
        <div className={styles.detailsWrapper}>
            <div className={styles.detailsInner}>
                <div className={`${styles.details} ${className}`}>{children}</div>
            </div>
        </div>
    )
}

// Compound component pattern for easier usage
ScoopAccordion.Summary = ScoopAccordionSummary
ScoopAccordion.Details = ScoopAccordionDetails
